<template>
  <span v-if="workingReward">
    <v-row class="mt-6">
      <v-col cols="12">
        <v-radio-group
          label="Destination"
          v-model="workingReward.destinationType"
          dense
          hide-details
          :rules="requiredRule"
          @change="onChange">
            <v-radio v-for="item in Object.entries(RewardDestinations)" v-bind:key="item[0]" :value="item[0]" :label="item[1]" :ref="`${item[0]}_Destination_Radio`"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-radio-group
          label="Source"
          v-model="workingReward.rewardSource"
          dense
          hide-details
          :rules="requiredRule"
          @change="onChange">
            <v-radio v-for="item in Object.entries(RewardSources)" v-bind:key="item[0]" :value="item[0]" :label="item[1]" :ref="`${item[0]}_Source_Radio`"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-radio-group
          label="Type"
          v-model="workingReward.calculationType"
          dense
          hide-details
          :rules="requiredRule"
          @change="onChange">
            <v-radio v-for="item in Object.entries(CalculationTypes)" v-bind:key="item[0]" :value="item[0]" :label="item[1]" :ref="`${item[0]}_Calculation_Type_Radio`"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <template v-if="workingReward.calculationType === 'PER_TRANSACTION_AMOUNT'">
      <v-row class="mt-6">
        <v-col cols="12">
          <v-radio-group
            label="Per Transaction Reward Method"
            v-model="workingReward.perTrxAmountCalcMethod"
            dense
            :rules="requiredRule"
            @change="onChange"
            ref="perTrxAmountCalcMethod">
              <v-radio v-for="item in Object.entries(PerTrxAmoundCalcMethods)" v-bind:key="item[0]" :value="item[0]" :label="item[1]" :ref="`${item[0]}_Calculation_Method_Radio`"/>
          </v-radio-group>
        </v-col>
      </v-row>

      <template v-if="workingReward.perTrxAmountCalcMethod === 'PERCENTAGE'">
        <v-row class="mt-6">
          <v-col cols="12">
            <v-text-field
              label="Reward Percentage"
              v-model="workingReward.perTrxTypePercentage"
              type="number"
              hint="Ex. 3.00"
              suffix="%"
              hide-spin-buttons
              dense
              :rules="requiredAndPositiveRule"
              @input="onChange"
              name="perTrxTypePercentage"
              ref="perTrxTypePercentage"
            />
          </v-col>
        </v-row>

        <v-row class="mt-6">
          <v-col cols="12">
            <v-select label="Transaction Type" outlined dense :items="Object.entries(RewardedTrxTypes)" v-model="workingReward.rewardedTrxType"
              item-text="1" item-value="0" :rules="requiredRule" @change="onChange" ref="rewardedTrxType"/>
          </v-col>
        </v-row>
      </template>
    </template>

    <v-row class="mt-8">
      <v-col cols="12">
        <v-text-field
          :label="getTotalMaximumAmountLabel()"
          v-model="workingReward.totalMaximumAmount"
          type="number"
          hint="Ex. 3.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="totalMaximumAmount"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6" v-if="workingReward.calculationType === 'PER_TRANSACTION_AMOUNT' && workingReward.perTrxAmountCalcMethod === 'PERCENTAGE'" ref="calculatedCashBackLimit">
      <v-col cols="12">
        Calculated Reward Limit: <strong>{{calculateRewardLimit()}}</strong>
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  FlexReward, RewardDestinations,
  RewardSources,
  CalculationTypes,
  PerTrxAmoundCalcMethods,
  RewardedTrxTypes,
} from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class FlexRewardEditor extends Vue {
  @Prop()
  value!:FlexReward;

  workingReward:FlexReward | null = null;

  // Make visible to template
  RewardDestinations:any = RewardDestinations;

  RewardSources:any = RewardSources;

  CalculationTypes:any = CalculationTypes;

  PerTrxAmoundCalcMethods:any = PerTrxAmoundCalcMethods;

  RewardedTrxTypes:any = RewardedTrxTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as FlexReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }

  getTotalMaximumAmountLabel() {
    if (this.workingReward!.calculationType === 'FLAT_AMOUNT') {
      return 'Amount';
    }

    if (this.workingReward!.perTrxAmountCalcMethod === 'FLAT_AMOUNT') {
      return 'Reward Amount';
    }

    return 'Transaction Limit';
  }

  calculateRewardLimit() : string {
    if (this.workingReward!.totalMaximumAmount && this.workingReward!.perTrxTypePercentage) {
      return `$${(this.workingReward!.totalMaximumAmount * this.workingReward!.perTrxTypePercentage / 100).toFixed(2)}`;
    }
    return '';
  }
}
</script>

<style lang="scss" scoped>
</style>
